import { Form } from "./form";
import {
    initiateMap,
    launchGeolocation,
    searchFieldLocation,
    recreateNode
} from "../maps/index";
import { formValues } from "./form";
import "whatwg-fetch";

String.prototype.padLeft = function (paddingValue) {
   return String(paddingValue + this).slice(-paddingValue.length);
};

export class RegistrationForm extends Form {
    constructor(form, container, view, nextFormName) {
        super(form);
        this.container = container;
        this.view = view;
        this.nextFormName = nextFormName;
        this.editForms = this.form.querySelectorAll(".edit");
        this.addFormBehavior();
    }

    addFormBehavior() {
        this.onSubmit();
        this.onEnter();

        if (this.editForms.length) {
            this.editForm();
        }

        if (this.form.classList.contains("facility-form")) {
            initiateMap(0, 0);
            launchGeolocation();
            searchFieldLocation();
        }
    }  
    
    // individual logic for each form submission
    // can vary depending on a number of things: 
    // DOB form 
    // if user is a student 
    // if user is coming from edit screen
    // if user is already in DB
    onSubmit() {
        let self = this;       

        if (this.submitButton.classList.contains("dob-button")) {
            this.dateOfBirthSubmit(self);
        } else {
            this.submitButton.addEventListener("click", function(event) {
                let disabled = event.srcElement.classList.contains("disabled");
                if (!disabled) {
                    self.storeFormInformation();
                    let locationField = document.querySelector(".location-row");
                    let locationStatusBar = document.querySelector(".facility-container-bar");

                    if (self.nextFormName !== "success-container") {
                        self.container.classList.add("hide");
                    }

                    if (formValues["connectionToY"] === "Student (Not Affiliated with a Y)" && self.nextFormName !== "success-container") {
                        locationField.classList.add("hide");
                        locationStatusBar.classList.add("hide");
                        formValues["location"] = "None";
                        formValues["associationNumber"] = "9900";

                        self.generateForm();
                        return self.view.nextForm("last-step-container");
                    }

                    if (self.nextFormName === "last-step-container") {
                        self.generateForm();                        
                    }                   

                    if (self.nextFormName === "success-container") {
                        return self.submitProfile();
                    }

                    if (self.container.classList.contains("back-to-review")) {
                        self.container.classList.remove("back-to-review");
                        self.generateForm();

                        if (formValues["connectionToY"] !== "Student (Not Affiliated with a Y)") {
                            locationField.classList.remove("hide");
                            locationStatusBar.classList.remove("hide");

                            if (formValues["location"] === "None") {
                                let selectedLocation = document.querySelector('.selected-location');
                                if (selectedLocation) {
                                    formValues["location"] = selectedLocation.querySelector('.location-name').innerHTML;
                                }
                                return self.view.nextForm("facility-container");
                            } else {
                                return self.view.nextForm("last-step-container");
                            }
                        }

                        return self.view.nextForm("last-step-container");
                    } else {
                        self.view.nextForm(self.nextFormName);
                    }
                } else {
                    self.container.querySelector(".warning").classList.remove("hide");
                }
            });
        }
    }

    // handles pressing 'enter' on each form
    onEnter() {
        document.addEventListener("keydown", e => {
            if (e.keyCode == 13) {
                let btn = document.querySelector(".form-container:not(.hide) .button:not(.disabled):not(.confirm-yes):not(.confirm-no)");
                
                if (btn) 
                    btn.click();
            }
        });
    }

    // shows correct form when user clicks 'edit' on final step
    editForm() {
        let self = this;
        for (let i = 0; i < this.editForms.length; i++) {
            this.editForms[i].addEventListener("click", function() {
                self.showForm(self.editForms[i].classList[1]);
            });
        }
    }

    // shows form
    showForm(container) {
        let containerName = container.split("-edit")[0];

        for (let i = 0; i < this.view.allForms.length; i++) {
            if (this.view.allForms[i].classList.contains(containerName)) {
                this.view.allForms[i].classList.remove("hide");
                this.view.allForms[i].classList.add("back-to-review");
                this.view.editProgressBar(containerName);
            }
        }

        this.container.classList.add("hide");
    }

    // deals with form that displays if record is found
    // i.e Is this you???
    confirmApprovalOfExistingRecord(record) {
        let self = this;
        let yes = document.querySelector(".confirm-yes");
        let no = document.querySelector(".confirm-no");

        yes.addEventListener("click", function() {
            let form = document.querySelector(".connection-form");
            let button = form.querySelector(".button");
            let eligibilityValues = form.querySelectorAll(".eligibility-value");

            for (let i = 0; i < eligibilityValues.length; i++) {
                if (eligibilityValues[i].value === record["eligibilityName"]) {
                    eligibilityValues[i].checked = true;
                    eligibilityValues[i].classList.add("selected");
                    eligibilityValues[i].classList.add("filled");
                    button.classList.remove("disabled");
                } else {
                    eligibilityValues[i].classList.add("fade");
                }
            }

            formValues["heldBatchApprovalConfirmed"] = record["heldBatchApprovalConfirmed"];
            formValues["eligibilityId"] = record["eligibilityId"];
            formValues["associationNumber"] = record["associationNumber"];
            formValues["connectionToY"] = record["connectionToY"];
            formValues["location"] = record["associationName"];
            formValues["gender"] = record["gender"];
            formValues["ethnicity"] = record["ethnicity"];
            formValues["ethnicityId"] = record["ethnicityId"];

            let nameEdit = document.querySelectorAll(".name-container-edit");
            for (var i = 0; i < nameEdit.length; i++)
                nameEdit[i].classList.add("hide");

            let dobEdit = document.querySelector(".dob-container-edit");
            dobEdit.classList.add("hide");

            let connectionEdit = document.querySelector(".connection-container-edit");
            connectionEdit.classList.add("hide");

            let facilityEdit = document.querySelector(".facility-container-edit");
            facilityEdit.classList.add("hide");

            self.generateForm();            
            self.view.nextForm("last-step-container");
        });

        no.addEventListener("click", function() {
            formValues["heldBatchApprovalConfirmed"] = false;            
            self.view.nextForm("gender-container");
        });
    }
    
	checkIfUserExists(userData) {
        let sendObject = {};
        let parseDate = formValues["dateOfBirth"].split("-");
        let newDate = parseDate[2] + "-" + parseDate[0].toString().padLeft('00') + "-" + parseDate[1].toString().padLeft('00');
		let url = window.location.origin + "/api/user-check";
        let self = this;
        let gif = document.querySelector(".check-user-gif");
        let dobButton = document.querySelector(".dob-button");

        gif.classList.remove("hide");
        dobButton.classList.add("hide");

		sendObject["dateOfBirth"] = newDate;
		sendObject["lastName"] = formValues["lastName"];
		sendObject["firstName"] = formValues["firstName"];		

        fetch(url, {
            method: "post",
            credentials: "same-origin",
			headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(sendObject)
        })
        .then(response => {
            if (response.status === 409) {
                formValues["heldBatchApprovalConfirmed"] = false;

                gtag("event", "Unsuccessful Profile Submit", {
                    event_category: "Engagement",
                    event_label: ""
                });

                gif.classList.add("hide");                
                dobButton.classList.remove("hide");

                return self.view.nextForm("user-denied-container");

            } else if (response.status === 404) {
                formValues["heldBatchApprovalConfirmed"] = false;
                gif.classList.add("hide");
                dobButton.classList.remove("hide");

                return self.continueToGenderForm(userData);

            } else if (response.status === 500) {
                formValues["heldBatchApprovalConfirmed"] = false;
                gif.classList.add("hide");
                dobButton.classList.remove("hide");

                return self.continueToGenderForm(userData);

            } else {
                gif.classList.add("hide");
                dobButton.classList.remove("hide");

                return response.json();
            }
        })
        .then(record => {                        
            if (record) {
                formValues["existingRecord"] = record; 
                
                let message = document.querySelector(".dynamic-message");                
                message.innerHTML = record["isThisYouMessage"];                
                
                self.confirmApprovalOfExistingRecord(record);                
                return self.view.nextForm('ask-user-container');
            }
        });
    }

    // continues straight to gender form if user is not found
    continueToGenderForm(userData) {
        let self = userData;
        self.container.classList.add("hide");

        if (self.container.classList.contains("back-to-review")) {
            self.container.classList.remove("back-to-review");
            self.generateForm();
            return self.view.nextForm("last-step-container");
        } else {
            return self.view.nextForm(self.nextFormName);
        }
    }

    // helper function to check if dates are in a certain range
    isInRange(number, min, max) {
        return number > min && number < max;
    }

    // submission logic for DOB form
    dateOfBirthSubmit(self) {
        this.submitButton.addEventListener("click", function() {
            let day = self.form.querySelector("#dob-day").value;
            let month = self.form.querySelector("#dob-month").value;
            let year = self.form.querySelector("#dob-year").value;
            let currentYear = new Date();

            if (self.isInRange(day, 0, 32) &&
                self.isInRange(month, 0, 13) && 
                self.isInRange(year, 1900, currentYear.getFullYear())) 
            {
                self.storeFormInformation();
                self.checkIfUserExists(self);
            }

            if (!self.isInRange(day, 0, 32)) {
                self.container.querySelector(".warning").classList.remove("hide");
            }

            if (!self.isInRange(month, 0, 13)) {
                self.container.querySelector(".warning").classList.remove("hide");
            }

            if (self.isInRange(day, 0, 32) && self.isInRange(month, 0, 13)) {
                self.container.querySelector(".warning").classList.add("hide");
            }

            recreateNode(document.querySelector(".dob-button"));
        });        
    }

    // dynamically fills in values for last step container
    generateForm() {
        let lastStepButton = document.querySelector(".last-step-button");
        lastStepButton.classList.add('disabled');

        let lastStepForm = document.querySelector(".last-step-form");
        let firstNameValue = lastStepForm.querySelector("#firstName");
        let lastNameValue = lastStepForm.querySelector("#lastName");
        let dobValue = lastStepForm.querySelector("#dob");
        let genderValue = lastStepForm.querySelector("#gender");
        let ethnicityValue = lastStepForm.querySelector("#ethnicity");
        let connectionValue = lastStepForm.querySelector("#connection");
        let locationValue = lastStepForm.querySelector("#location");

        let submissionValues = document.querySelectorAll(".submission-error");

        for (let i = 0; i < submissionValues.length; i++) {
            submissionValues[i].classList.add("hide");
        }

        // prevents submitting form when editing another field on separate form
        setTimeout(function(){ 
            lastStepButton.classList.remove('disabled');
        }, 1000);

        for (let field in formValues) {
            switch (field) {
                case "firstName":
                    firstNameValue.innerHTML = formValues[field];
                    break;
                case "lastName":
                    lastNameValue.innerHTML = formValues[field];
                    break;
                case "dateOfBirth":
                    dobValue.innerHTML = formValues[field];
                    break;
                case "gender":
                    genderValue.innerHTML = formValues[field];
                    break;
                case "ethnicity":
                    ethnicityValue.innerHTML = formValues[field];
                    break;
                case "connectionToY":
                    connectionValue.innerHTML = formValues[field];
                    break;
                case "location":
                    locationValue.innerHTML = formValues[field];
                    break;
            }
        }
    }

    // final profile submission
    submitProfile() {
        let sendObject = {};
        let parseDate = formValues["dateOfBirth"].split("-");
        let newDate = parseDate[2] + "-" + parseDate[0].toString().padLeft('00') + "-" + parseDate[1].toString().padLeft('00');
        let url = window.location.origin + "/api/registration";

        let editButtons = document.querySelectorAll('.edit');
        let lastStepButton = document.querySelector('.last-step-button');
        let submitGif = document.querySelector('.submit-profile-gif');

        for (let i = 0; i < editButtons.length; i++) {
            editButtons[i].classList.add('hide');
        }

        lastStepButton.classList.add('disabled', 'hide');
        submitGif.classList.remove('hide');

        sendObject["eligibilityId"] = Number(formValues["eligibilityId"]);
        sendObject["dateOfBirth"] = newDate;
        sendObject["ethnicityId"] = Number(formValues["ethnicityId"]);
        sendObject["firstName"] = formValues["firstName"];
        sendObject["lastName"] = formValues["lastName"];
        sendObject["gender"] = formValues["gender"];
        sendObject["location"] = formValues["location"];
        sendObject["associationNumber"] = formValues["associationNumber"];
        sendObject["heldBatchApprovalConfirmed"] = formValues["heldBatchApprovalConfirmed"];

        if (sendObject["connectionToY"] === "Student (Not Affiliated with a Y)") {
            sendObject["location"] = "None";
        }

        fetch(url, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(sendObject)
        }).then(function(data) {
            if (data.status === 201) {
                let lastStep = document.querySelector(".last-step-container");
                let success = document.querySelector(".success-container");
                let progressBar = document.querySelector(".progress-bar-container");
                let firstName = document.querySelector("#welcome-name");

                progressBar.classList.add("hide");
                firstName.innerHTML = formValues["firstName"];
                lastStep.classList.add("hide");
                success.classList.remove("hide");
                
                //call to add a "forceLogin" claim to claim bag
                fetch('/Signout/AddForceLoginClaim')
                    .then(response => {
                        if(!response.ok) 
                            throw Error(response.statusText);

                        return response;
                    })
                    .then(response => {
                        return response.json();
                    });

                gtag("event", "Successful Profile Submit", {
                    event_category: "Engagement",
                    event_label: ""
                });
            }

            if (data.status === 500) {
                let submissionError = document.querySelector(".server-error");
                submissionError.classList.remove("hide");
                lastStepButton.classList.remove('disabled', 'hide');
                submitGif.classList.add('hide');

                for (let i = 0; i < editButtons.length; i++) {
                    editButtons[i].classList.remove('hide');
                }

                gtag("event", "Unsuccessful Profile Submit", {
                    event_category: "Engagement",
                    event_label: ""
                });
            }

            if (data.status === 400) {
                let submissionError = document.querySelector(".bad-request-error");
                submissionError.classList.remove("hide");
                lastStepButton.classList.remove('disabled', 'hide');
                submitGif.classList.add('hide');

                for (let i = 0; i < editButtons.length; i++) {
                    editButtons[i].classList.remove('hide');
                }

                gtag("event", "Unsuccessful Profile Submit", {
                    event_category: "Engagement",
                    event_label: ""
                });
            }

            if (data.status === 409) {
                let submissionError = document.querySelector(".conflict-error");
                submissionError.classList.remove("hide");
                lastStepButton.classList.remove('disabled', 'hide');
                submitGif.classList.add('hide');

                for (let i = 0; i < editButtons.length; i++) {
                    editButtons[i].classList.remove('hide');
                }

                gtag("event", "Unsuccessful Profile Submit", {
                    event_category: "Engagement",
                    event_label: ""
                });
            }
        });
    }    

    // stores values in formValues object as user progresses through form
    // formValues is what ultimately gets sent to the DB
    // takes into account for values being pulled from DB for gender, ethnicity
    storeFormInformation() {
        for (let i = 0; i < this.inputFields.length; i++) {
            if (this.inputFields[i].classList.contains("ethnicity-value") && this.inputFields[i].classList.contains("selected")) {
                let ethnicityId = this.inputFields[i].id.split("-")[1];
                formValues["ethnicityId"] = ethnicityId;
            }

            if (this.inputFields[i].classList.contains("eligibility-value") && this.inputFields[i].classList.contains("selected")) {
                let eligibilityId = this.inputFields[i].id.split("-")[1];
                formValues["eligibilityId"] = eligibilityId;
            }

            if (!this.inputFields[i].classList.contains("geolocation-field")) {
                if (this.inputFields[i].checked &&
                    (this.inputFields[i].type === "radio" || this.inputFields[i].type === "checkbox")) {
                    if (this.inputFields[i].value === "custom") {
                        formValues[this.inputFields[i].name] = this.form.querySelector(".custom-input").value;
                    } else {
                        formValues[this.inputFields[i].name] = this.inputFields[i].value;
                    }
                }

                if (this.inputFields[i].type === "text" && !this.inputFields[i].classList.contains("custom-input")) {
                    formValues[this.inputFields[i].name] = this.inputFields[i].value;
                }
            }
        } 

        this.view.sanitizeFormData();
    }
}